<template>
  <v-container
    grid-list-xl
    fluid
    style="padding-top: 0;">
    <v-layout
      v-if="isAdmin() || isSuperAdmin() || isModerator() || isAccountant()"
      wrap
    >
      <v-flex
        md12
      >
        <template class="float-right">
          <v-btn
            v-if="isAdmin() || isSuperAdmin() || isModerator() || isAccountant()"
            color="success"
            dark
            style="float: right;"
            @click="onShowAddFeedback(null)"
          >
            {{ $t('common.add') }}
          </v-btn>
        </template>
        <v-data-table
          v-if="isAdmin() || isSuperAdmin() || isModerator() || isAccountant()"
          :no-data-text="$t('common.noDataAvailable')"
          :headers="userHeaders"
          :items="feedbackTemplateList"
          :single-select="true"
          hide-actions
        >
          <template
            slot="headerCell"
            slot-scope="{ header }"
          >
            <span
              class="text--darken-3 font-medium"
              v-text="$t(header.text)"
            />
          </template>
          <template
            v-slot:items="props"
          >
            <td style="white-space: nowrap; width: 5%;">{{ props.item.stt }}</td>
            <td
              class="cursor-pointer"
              @mouseover="onHoverEmail(props.item)"
              @mouseleave="onLeaveEmail(props.item)"
            >
              <div>
                <span
                  class="pb-1"
                  style="border-bottom: 1px dashed #5cb860">{{ props.item.templateName }}</span>
                <div
                  v-show="props.item.isShowTool"
                  class="mt-1"
                  style="display: flex; white-space: nowrap">
                  <span
                    class="text-success hover-detail-text"
                    @click="onShowFeedbackTemplate(props.item)">{{ $t('users.viewDetail') }}</span>
                  <span
                    v-if="isAdmin() || isSuperAdmin() || isAccountant()"
                    class="mx-2">|</span>
                  <span
                    v-if="isAdmin() || isSuperAdmin() || isAccountant()"
                    class="hover-delete-text"
                    style="color: red;"
                    @click="onShowDeleteFeedbackTemplate(props.item.id)">{{ $t('common.delete') }}</span>
                </div>
              </div>
            </td>
            <td>{{ props.item.ratingNumber }}</td>
            <td class="text-xs-center">
              <v-tooltip
                v-if="isAdmin() || isSuperAdmin() || isAccountant() || isModerator()"
                top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    :loading="props.item.isLoading"
                    class="mx-2"
                    fab
                    small
                    color="success"
                    style="color: #ffffff;"
                    v-on="on"
                    @click="onShowModalFeedbackItem(props.item)">
                    <v-icon dark>mdi-plus</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('feedback.feedbackOptions.answerOption') }}</span>
              </v-tooltip>
            </td>
          </template>
        </v-data-table>
      <!-- </material-card> -->
      </v-flex>
    </v-layout>
    <pagination
      :total="feedbackTemplatePaginate.totalPage"
      :current-page="feedbackTemplatePaginate.currentPage"
      :row-per-page="feedbackTemplatePaginate.rowPerPage"
      @onPageChange="onPageChange"
    />
    <snack-bar
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"/>
    <confirm-modal
      ref="confirmModal"
      :title="confirmModalTitle"
      @onConfirm="onDeleteFeedbackTemplate()"
    />
    <feedbackTemplateDetail
      ref="feedbackTemplateDetail"
      @getFeedbackTemplateList="getFeedbackTemplateList()"/>
    <loadingBar :is-loading="isLoading" />
    <!--  -->
    <feedbackInTemplate
      ref="feedbackInTemplate"/>
  </v-container>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import functionUtils from 'utils/functionUtils'
import ToastType from 'enum/toastType'
import feedbackTemplateDetail from './FeedbackTemplateDetail'
import feedbackInTemplate from './FeedbackInTemplate'
import Avatar from 'vue-avatar'
import ConfirmModal from 'Components/ConfirmModal'
import stringUtils from 'utils/stringUtils'
import RoleType from 'enum/roleType'

export default {
  components: {
    feedbackTemplateDetail: feedbackTemplateDetail,
    Avatar,
    ConfirmModal,
    feedbackInTemplate
  },
  data: () => ({
    userHeaders: [
      {
        sortable: false,
        text: 'common.nonumber',
        value: 'stt'
      },
      {
        sortable: false,
        text: 'feedback.feedbackTemplate.templateName',
        value: 'templateName'
      },
      {
        sortable: false,
        text: 'feedback.feedbackTemplate.ratingNumber',
        value: 'ratingNumber'
      },
      {
        sortable: false,
        text: 'common.actions',
        value: 'actions',
        align: 'center'
      }
    ],
    feedbackTemplateList: [],
    feedbackTemplatePaginate: {
      totalPage: 1,
      currentPage: 1,
      rowPerPage: 1
    },
    feedbackTemplateSelected: {
      id: null
    },
    rolesSelected: [],
    isUpdate: true,
    dobDefault: null,
    menu: false,
    isShowUserDetail: true,
    confirmModalTitle: '',
    selected: [],
    feedbackTemplateSearch: {
      searchText: null
    },
    gender: stringUtils.GenderList,
    genderList: null,
    isLoading: false,
    isActive: false,
    modalConfirmType: {
      DELETE_USER: 1,
      FORGOT_PASSWORD_USER: 2
    },
    modalConfirmTypeSelected: null,
    userForgotPassSelected: null
  }),
  computed: {
    ...mapGetters(['GET_SNACK_BAR', 'GET_FEEDBACK_TEMPLATE_DATA', 'GET_CURRENT_ACCOUNT'])
  },
  watch: {
    GET_FEEDBACK_TEMPLATE_DATA () {
      this.feedbackTemplatePaginate.currentPage = this.GET_FEEDBACK_TEMPLATE_DATA.paginate.currentPage
      this.feedbackTemplatePaginate.totalPage = this.GET_FEEDBACK_TEMPLATE_DATA.paginate.totalPage
      this.feedbackTemplatePaginate.rowPerPage = this.GET_FEEDBACK_TEMPLATE_DATA.paginate.perPage
      let feedbackTemplateList = this.GET_FEEDBACK_TEMPLATE_DATA.results
      this.feedbackTemplateList = []
      for (let i = 0, size = feedbackTemplateList.length; i < size; i++) {
        let userObj = {
          stt: i + 1 + (this.GET_FEEDBACK_TEMPLATE_DATA.paginate.currentPage - 1) * this.GET_FEEDBACK_TEMPLATE_DATA.paginate.pageSize,
          id: feedbackTemplateList[i].id,
          templateName: feedbackTemplateList[i].name,
          ratingNumber: feedbackTemplateList[i].rating_range,
          isShowTool: false,
          isLoading: false
        }
        this.feedbackTemplateList.push(userObj)
      }
      this.isLoading = false
    }
  },
  created () {
    this.getFeedbackTemplateList()
    this.GET_FEEDBACK_OPTION()
  },
  methods: {
    /**
     * Hover email
     */
    onHoverEmail: function (userItem) {
      userItem.isShowTool = true
    },
    /**
     * Leave email
     */
    onLeaveEmail: function (userItem) {
      userItem.isShowTool = false
    },
    /**
     * Check is super admin
     */
    isSuperAdmin: function () {
      return functionUtils.isSuperAdmin(this.GET_CURRENT_ACCOUNT)
    },
    // Check is admin
    isAdmin: function () {
      return functionUtils.hasSystemRole(RoleType.ADMIN, this.GET_CURRENT_ACCOUNT)
    },
    isModerator: function () {
      return functionUtils.hasSystemRole(RoleType.MODERATOR, this.GET_CURRENT_ACCOUNT)
    },
    // Check Accountant
    isAccountant: function () {
      return functionUtils.hasSystemRole(RoleType.ACCOUNTANT, this.GET_CURRENT_ACCOUNT)
    },
    /**
     * Show modal view add feedback
     */
    onShowAddFeedback: function () {
      this.$refs.feedbackTemplateDetail.onShowAddNew()
    },
    /**
     * Show modal view detail feedback
     */
    onShowFeedbackTemplate: function (item) {
      this.$refs.feedbackTemplateDetail.onShowModal(item)
    },
    /**
     * Search
     */
    onSearch: function (text) {
      this.feedbackTemplateSearch.searchText = text
      this.getFeedbackTemplateList()
    },
    /**
     * Show modal delete user
     */
    onShowDeleteFeedbackTemplate: function (feedbackTemplateId) {
      this.feedbackTemplateSelected.id = feedbackTemplateId
      this.confirmModalTitle = this.$t('feedback.feedbackTemplate.confirmDeleteFeedbackTemplate')
      this.modalConfirmTypeSelected = this.modalConfirmType.DELETE_USER
      this.$refs.confirmModal.onShowModal()
    },
    /**
     * Delete user
     */
    onDeleteFeedbackTemplate: function () {
      this.DELETE_FEEDBACK_TEMPLATE({ id: this.feedbackTemplateSelected.id }).then(
        function () {
          this.feedbackTemplateSelected.id = null
          this.ON_SHOW_TOAST({
            'message': this.$t('common.success'),
            'styleType': ToastType.SUCCESS
          })
          this.getFeedbackTemplateList()
        }.bind(this)
      )
    },
    /**
     * Get user list
     */
    getFeedbackTemplateList: function () {
      this.isLoading = true
      let filter = {
        params: {
          page: this.feedbackTemplatePaginate.currentPage,
          searchText: this.feedbackTemplateSearch.searchText
        }
      }
      this.GET_FEEDBACK_TEMPLATE(filter).then(
        function () {}
      ).catch(
        function () {
          this.isLoading = false
        }.bind(this)
      )
    },
    /**
     * Page change
     */
    onPageChange: function (page) {
      this.feedbackTemplatePaginate.currentPage = page
      this.getFeedbackTemplateList()
    },
    // show feedback item
    onShowModalFeedbackItem: function (data) {
      this.$refs.feedbackInTemplate.onShowModal(data.id)
    },
    // get feedback template list
    getFeedbackTemplateDataList: function (text) {
      this.onSearch(text)
      this.GET_FEEDBACK_OPTION()
    },
    ...mapActions(['GET_FEEDBACK_TEMPLATE', 'GET_FEEDBACK_OPTION', 'DELETE_FEEDBACK_TEMPLATE', 'ON_SHOW_TOAST'])
  }
}
</script>
<style lang="scss" scoped>
@import "../../styles/material-dashboard/_colors.scss";
/deep/ .test-primary {
  background-color: #c7c7c7c7 !important;
}
/deep/ .test-primary:hover {
  background-color: #c7c7c7c7 !important;
}
/deep/ .theme--light.v-list {
  background-color: transparent;
}
.border-style {
  border-bottom: 2px solid $border-color;
}
.cursor-pointer {
  cursor: pointer !important;
}
.hover-detail-text:hover {
  border-bottom: 1px solid $border-color;
}
.hover-delete-text:hover {
  border-bottom: 1px solid $border-color;
}
.hover-active-text:hover {
  border-bottom: 1px solid $border-color;
}
//
.product-img-class {
  max-width: 60px;
  max-height: 60px;
}
.product-img-div {
  width: 60px;
  height: 60px;
}
</style>
